import { render, staticRenderFns } from "./Machine.vue?vue&type=template&id=674ba1bc&scoped=true&"
import script from "./Machine.vue?vue&type=script&lang=js&"
export * from "./Machine.vue?vue&type=script&lang=js&"
import style0 from "./Machine.vue?vue&type=style&index=0&id=674ba1bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ba1bc",
  null
  
)

export default component.exports